import { Row } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import CardNew from "components/molecules/Card/CardNew";
import Alert from "components/molecules/Alert/Alert";
import Column from "components/atoms/Column/Column";
import Invoice from "pages/common/ShipmentBilling/components/Invoice/Invoice";
import AuditLog from "pages/common/ShipmentBilling/components/AuditLog/AuditLog";
import Files from "pages/common/ShipmentBilling/components/Files/Files";
import Comments from "pages/common/ShipmentBilling/components/Comments/Comments";
import ShipmentBillingActions from "../ShipmentBillingActions/ShipmentBillingActions";
import ShipmentBillingNav from "../ShipmentBillingNav/ShipmentBillingNav";

interface BillingInvoiceProps {
  isLoading: boolean;
  currentInvoice: any;
  totalInvoice: number;
}

function BillingInvoice({ isLoading, currentInvoice, totalInvoice }: BillingInvoiceProps) {
  const [searchParams] = useSearchParams();
  const currentInvoiceId = searchParams.get("invoice");
  const isCustomsInvoice = currentInvoice?.invoice_type === "customs_broker_invoice";

  return (
    <Row className="pl-8 pr-8">
      <Column md={8} className="mb-15">
        <CardNew>
          <ShipmentBillingNav />
          <div>
            <div className="d-flex justify-content-between align-items-center mt-3 mb-4 ml-2">
              <div className="d-flex">
                <h3>{currentInvoiceId}</h3>
                {isCustomsInvoice && (
                  <Alert noIcon className="ml-xs ml-md" variant="warning">
                    <FormattedMessage id="invoices.customBrokerageInvoice" defaultMessage="Customs Brokerage Invoice" />
                  </Alert>
                )}
              </div>
              <ShipmentBillingActions />
            </div>
          </div>
          <Invoice isLoading={isLoading} invoice={currentInvoice} totalInvoice={totalInvoice} />
        </CardNew>
      </Column>
      <Column md={4}>
        <AuditLog invoiceId={currentInvoice?.invoice_id} className="mb-15" />
        <Files
          isLoading={isLoading}
          invoiceId={currentInvoice.invoice_id}
          isInvoiceApproved={currentInvoice.invoice_status === "Approved"}
        />
        <Comments invoiceId={currentInvoice?.invoice_id} />
      </Column>
    </Row>
  );
}

export default BillingInvoice;
